import { WelcomePremiumOfferState } from "src/features/offers/premiumEntrance/welcomePremiumOffer/state/slice";

export const welcomePremiumOfferSelectors = {
  getOffer: (state: WelcomePremiumOfferState) => state.welcomeOffer,
};
